import { datetime, convertYYYYMMDD } from '../../../util/date-time';
export function marketsOptionChainTransform(data, params, needSecurityFields) {
    /**
    * data format
    {
        security: 'XNYS:IBM',
        instrument: '126.1.IBM',
        chain: [{
            expireDate: '20170915',
            options: [{
                symbol: 'IBM   170915C00075000',
                instrument: '126.2.IBM7IFC075000',
                listMarket: '3',
                type: 'Calls',
                strikePrice: '75.0'
            }, {
                symbol: 'IBM   180209C00139000',
                instrument: '126.2.IBM8B9C139000',
                listMarket: '3',
                type: 'Calls',
                strikePrice: '139.0'
            }, ...]
        }, ...]
    }
    */
    const ret = {
        security: needSecurityFields.queryKey,
        instrument: needSecurityFields.instrument
    };
    if (data && data.Chain) {
        ret.chain = [];
        const chainData = data.Chain;
        const rootExchange = chainData.QueryKey.replace(/:\w+/g, '');
        /**
         * Rearrange Chain.Details and Chain.Expirations
         * Combine Details and Expirations value;
         */
        chainData.Expirations.forEach((dateValue, index) => {
            const time = datetime(dateValue).getTime();
            // filter no need data, wrong date.
            if (time + 24 * 60 * 60 * 1000 > new Date().getTime()) {
                const detailsObj = {
                    expireDate: convertYYYYMMDD(dateValue),
                    options: []
                };
                const detailsDataArr = chainData.Details[index];
                // this circulation for getting detailsObj.items from detailsDataArr
                compositeTickerObject(
                    detailsDataArr,
                    detailsObj,
                    ret.chain,
                    rootExchange
                );
            }
        });
    }
    return ret;
}

function compositeTickerObject(dateArray, detailsObj, rootArray, rootExchange) {
    dateArray.forEach(dataItem => {
        const infoData = dataItem['Info'] || [];
        const feedData = dataItem['Feed'] || [];

        detailsObj.options.push({
            symbol: infoData[5],
            instrument: `${useSpecialMarket(rootExchange, feedData[1])}.2.${
                feedData[0]
            }`,
            listMarket: feedData[1],
            type: getOptionType(infoData[3]),
            strikePrice: infoData[4]
        });
    });
    rootArray.push(detailsObj);
}

function getOptionType(char) {
    if (char === 'C') {
        return 'Calls';
    } else if (char === 'P') {
        return 'Puts';
    } else {
        return '';
    }
}

function useSpecialMarket(exchangeID, feed) {
    const intExchangeID = +exchangeID;
    if (intExchangeID === 127) {
        return feed;
    }
    if (
        intExchangeID < 126 ||
        intExchangeID === 131 ||
        intExchangeID === 149 ||
        intExchangeID === 157
    ) {
        return 126;
    }
    return exchangeID;
}
